import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable ,  Subscription  } from 'rxjs';

import { ApiError, BaseTypeahead, BaseTypeaheadService, MessageService } from '../../../core';
import { EnumUsuarioEscopo } from '../enums/usuario-escopo.enum';
import { Usuario } from '../usuario';
import { usuarioAtivo, usuarioInativo } from '../usuario-situacao';
import { TypeaheadUsuarioHttpService } from './typeahead-usuario-http.service';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { situacaoAtivo } from 'app/home/cotacao-item-formulario';

@Component({
    selector: 'sgt-typeahead-usuario',
    templateUrl: './typeahead-usuario.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TypeaheadUsuarioComponent), multi: true },
    ]
})
export class TypeaheadUsuarioComponent implements OnInit, AfterViewInit, BaseTypeahead<Usuario> {
    @Input() entity: Usuario;
    @Output() ngModelChange = new EventEmitter<Usuario>();

    @Input() ativos: boolean;
    @Input() inativos: boolean;
    @Input() perfil: number;
    @Input() escopo: EnumUsuarioEscopo;
    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() container: string;
    @Input() autofocus = false;
    @Input() dropup = false;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Output() typeaheadChange = new EventEmitter<Usuario>();

    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Usuario[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private typeaheadUsuarioHttpService: TypeaheadUsuarioHttpService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).focus();
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }
            // Situações
            const situacoes = this.getFilterSituacoes();

            this.currentRequest = this.typeaheadUsuarioHttpService.search(this.typeaheadToken, situacoes, this.perfil, this.typeaheadOptionsLimit, this.escopo)
                                        .subscribe(
                                            (entities: Usuario[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar os usuários. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        });
    }

    /** Obtem as situações para o filtro conforme os inputs informados */
    private getFilterSituacoes(): number[] {
        const situacoes: number[] = [];
        // Ativos
        if (this.ativos) {
            situacoes.push(usuarioAtivo.id);
        }
        // Inativos
        if (this.inativos) {
            situacoes.push(usuarioInativo.id);
        }

        return situacoes;
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar o Usuario no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

   /** Quando recebe um objeto usuario de "fora" do component */
    writeValue(value: Usuario) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
